'use client';
export const dynamic = 'force-dynamic';

import { BbcLogo } from '@/ui/core/logos';
import { FlexAuto, FlexRow } from '@/ui/controls/layout';
import { useSearchParams } from 'next/navigation';
import { urls } from '@/common/urls';
import { LinkButton } from '@/ui/controls/buttons';
import { CLP } from '@/common/schema/claims-process';
import { SERVICES } from '@/fe/services';
import { CLM } from '@/common/schema/claims';

export default function AppHeader() {
  const searchParams = useSearchParams();
  const ts           = searchParams.get('ts') || "NOW";
  const URLS         = urls({ ts });
  const { CTX }      = SERVICES();
  const currentUser  = CTX.useCurrentUser();
  const { currentApp, isAppNoAccessPage } = CTX.useCurrentApp();

  return <>
    <FlexRow items="center" className="gap-5 py-5 px-10 bg-deep-blue text-pale-blue">
      { <>
        <LinkButton url={currentApp ? URLS.home({ ts, app: currentApp }) : URLS.root({ ts })} enabled={currentUser && !isAppNoAccessPage && currentApp !== undefined}>
          <BbcLogo className="w-64 h-16" />
        </LinkButton>
        <div className="text-title-md">{currentApp?.name}</div>
      </>}
      <FlexAuto />
      { currentUser && !isAppNoAccessPage && currentApp && <>
          { MenuItems({ currentUser, currentApp, ts }).filter((menuItem) => menuItem.isActive).map((menuItem) => (
            <LinkButton key={menuItem.name} url={menuItem.url} className="text-title-md ml-10 text-pale-blue hover:text-white">
              {menuItem.name}
            </LinkButton>
          ))}
      </>}
    </FlexRow>
  </>;
}

type MenuItem = {
  name:     string;
  url:      string;
  isActive: boolean;
}

function MenuItems({ currentUser, currentApp, ts }: { currentUser: CLM.User, currentApp: CLM.App, ts: string }) : MenuItem[] {
  const URLS = urls({ ts });

  const isReturnsCoordinator = currentUser.settings.persona === CLP.ActorType.RETURNS_COORDINATOR;
  const isDistributor        = currentUser.settings.persona === CLP.ActorType.DISTRIBUTOR;

  return [
    { name: "Home",         url: URLS.                       home    ({ app: currentApp }), isActive: true                 },
    { name: "Create Claim", url: URLS.tracker.               newClaim(                   ), isActive: isReturnsCoordinator },
    { name: "Create Claim", url: URLS.claimsApp.distributors.newClaim(                   ), isActive: isDistributor        },
    { name: "Sign Out",     url: URLS.                       logout  (                   ), isActive: true                 },
  ];
}
